import apiHttpRequest from "services/api-http-request";

const listWeatherKorea = async () => {
  let weatherStations = [];

  try {
    weatherStations = await apiHttpRequest.get('/outdoor/weather_korea');
  } catch (e) {
    console.error(e);
  }

  return weatherStations;
}

const getWeatherKoreaDetail = async (sensorType, startTime, endTime) => {
  const params = {};

  
  

  if (startTime && startTime.length > 0) {
    params.start_time = startTime
  }

  if (endTime && endTime.length > 0) {
    params.end_time = endTime;
  }

  let detail = {};

  try {

    detail = await apiHttpRequest.get(`/outdoor/weather_korea/${sensorType}`, params);
  } catch (e) {
    console.error(e);
  }

  return detail
}

export default {
  listWeatherKorea,
  getWeatherKoreaDetail
}